import {Link} from "react-router-dom"
import {Collapse,Card,Space,Empty ,Button, message} from "antd"
import { useState, useMemo, useEffect, useCallback } from "react";
import InstituteService from "../../../services/InstituteService";
import ReactHtmlParser from "react-html-parser";
import { useLocation,useHistory,useParams} from "react-router-dom"
import { useSelector } from 'react-redux';
import { selectUser } from '../../../Auth/userReducer';


const {Panel}=Collapse;


function callback(key) {
  console.log(key);
}

const RolesPermited=[
  "Coordinador del instituto",
]

export default function InstituteInformation(props){
    const {Body:Institute}=props
    const user= useSelector(selectUser)
    const history = useHistory();
    const { search } = useLocation();
    const searchParams = useMemo(
        () => new URLSearchParams(search),[search]
      );
  const {id:InstituteID}=useParams()
  const [instituteData,setInstituteData]=useState()
  const [permissionComponents,setPermissionComponents]=useState(false)

  let listOptions=[{
    label:"Campo de acción del instituto",
    key:"action",
    data: instituteData?.action,
  },
  {
    label: "Objetivo del instituto",
    key: "objetive",
    data: instituteData?.objetive,
  },
  {
    label: "Mision del instituto",
    key: "mision",
    data: instituteData?.mision,
  },
  {
    label: "Vision del instituto",
    key: "vision",
    data: instituteData?.vision,
  },
  ]

  const getInstituteDataByInstitute=useCallback(()=>{
    InstituteService.getInstituteDataByInstitute(InstituteID).then((res)=>{
      console.log(res.data)
      if(res.data?.success){
        setInstituteData(res.data?.response);
      }
      else{
        message.error(res.data?.description)
      }
    })
  })

  const verificityPermissionRol=()=>{
    return RolesPermited.includes(user.rolName)
}
  
  useEffect(()=>{
      if (searchParams.get('option')!=="DataMisionAndVision") {
          searchParams.set('option', 'DataMisionAndVision');
          history.replace({ search: searchParams.toString() });
      }
    setPermissionComponents(verificityPermissionRol())  
    getInstituteDataByInstitute();
  },[])
  return (
    <>
    { permissionComponents &&
    (<Card>
      <Space>
        {instituteData==null &&(<Link 
        style={{display:"flex", flexDirection:"column"}} 
        to={{pathname:"/institute/detail/"+Institute?.id+"/objetives/create",state:{instituteData:instituteData,list:listOptions}}}
        >
          <Button 
          key={"createBtn"}
          >
            Añadir información
          </Button>
        </Link >)}  
        {instituteData!=null &&(<Link 
        style={{display:"flex", flexDirection:"column"}} 
        to={{pathname:"/institute/detail/"+Institute?.id+"/objetives/update",state:{instituteData:instituteData,list:listOptions}}}
        >
          <Button
          key={"updateBtn"}>
            Editar informacion
          </Button>
        </Link>)}
      </Space>
    </Card>)
    }
    <Card>
      {instituteData ? (<Collapse onChange={callback}>
        <Panel header="Campo de acción del instituto" key="1">
          <p>{ReactHtmlParser(instituteData?.action)}</p>
        </Panel>
        <Panel header="Objetivo del instituto" key="2">
          <p>{ReactHtmlParser(instituteData?.objetive)}</p>
        </Panel>
        <Panel header="Misión del instituto" key="3">
          <p>{ReactHtmlParser(instituteData?.mision)}</p>
        </Panel>
        <Panel header="Visión del instituto" key="4">
          <p>{ReactHtmlParser(instituteData?.vision)}</p>
        </Panel>
        
      </Collapse>): <Empty/>}
    </Card>
    </>
  )
} 